import { PaymentDirectiveModule } from '@b2b/common/directives';
import { ReservationInputDirectiveModule } from '@b2b/common/directives/reservationInput';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsListAdminBookingControllerModule } from './controllers/ProgramsListAdminBookingController';

export const ProgramsListAdminBookingView = angular
  .module('acme.view.application.programs.list.admin.booking', [
    uiRouter,
    'ui.bootstrap',
    PaymentDirectiveModule,
    'acme.common.directive.integer',
    ReservationInputDirectiveModule,
    ProgramsListAdminBookingControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const programsListAdminBooking = {
      name: 'application.programs.listAdminBooking',
      url: '/booking/:id?orderId',
      views: {
        'subview-main': {
          controller: 'ProgramsListAdminBookingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/list/admin/booking/booking.tpl.html',
        },
      },
      data: {
        pageTitle: 'Re-book Order',
        permissions: ['ORDER_REBOOK'],
      },
      resolve: {
        EventData: [
          '$stateParams',
          'ApiService',
          function ($stateParams, ApiService) {
            return ApiService.program.instances.detail($stateParams.id);
          },
        ],
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
      },
    };

    $stateProvider.state(programsListAdminBooking);
  }).name;
